import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { NeuButton, NeuCard } from "../components/neu/Neu";
import { useCachedResource } from "../hooks/useCachedResource";
import { expiringDocuments } from "../api/documents";
import { ExpiryTable } from "../features/admin/ExpiryTable";

const WINDOWS = [30, 60, 90];

export default function DocumentsPage() {
  const { t } = useTranslation();
  const [days, setDays] = useState(60);
  const { data, loading } = useCachedResource(`documents:${days}`, () => expiringDocuments(days), [days]);
  const alerts = data || [];

  return (
    <AppShell title={t("docs.title")} subtitle={t("docs.subtitle")}>
      <div className="grid gap-6" data-testid="documents-page">
        <NeuCard className="p-5">
          <p className="label-xs mb-3">{t("docs.window")}</p>
          <div className="flex flex-wrap gap-2">
            {WINDOWS.map((w) => (
              <NeuButton
                key={w}
                variant={w === days ? "primary" : undefined}
                className="px-4 py-2"
                data-testid={`docs-window-${w}`}
                onClick={() => setDays(w)}
              >
                {t("docs.days", { days: w })}
              </NeuButton>
            ))}
            <span className="ms-auto self-center text-xs text-muted-foreground" data-testid="docs-count">
              {alerts.length}
            </span>
          </div>
        </NeuCard>
        {loading ? <p className="text-sm text-muted-foreground">{t("app.loading")}</p> : <ExpiryTable alerts={alerts} />}
      </div>
    </AppShell>
  );
}
